import { render, staticRenderFns } from "./NameEmojiInput.vue?vue&type=template&id=2f8131dd&scoped=true&"
import script from "./NameEmojiInput.vue?vue&type=script&lang=js&"
export * from "./NameEmojiInput.vue?vue&type=script&lang=js&"
import style0 from "./NameEmojiInput.vue?vue&type=style&index=0&id=2f8131dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8131dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f8131dd')) {
      api.createRecord('2f8131dd', component.options)
    } else {
      api.reload('2f8131dd', component.options)
    }
    module.hot.accept("./NameEmojiInput.vue?vue&type=template&id=2f8131dd&scoped=true&", function () {
      api.rerender('2f8131dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/helpcenter/pages/categories/NameEmojiInput.vue"
export default component.exports